import { ComingSoonPanel, IconAddon, PageHeader } from '@shared/ui';

export function AddonsPage() {
    return (
        <>
            <PageHeader
                eyebrow="Configuration"
                title="Add-ons"
                description="Commercial modules a client can purchase. Each add-on bundles feature flags and entitlement limits — enabling one flips its flags on for that tenant."
            />
            <ComingSoonPanel
                icon={<IconAddon className="size-6" />}
                title="Add-ons catalog"
                blurb="The add-on catalog, per-tenant subscriptions (trial / active / suspended), and the flag-bundle grants land here in Phase 2."
            />
        </>
    );
}
